import { useTranslation } from '@hooks';
import { ExternalRoutes, RoutePath } from '@constants/routes';
import { HelpCenterIcon, ReferralIcon, SettingsIcon } from 'assets/images/sidebar';

const useProfileMenuItems = () => {
    const { t, i18n } = useTranslation();

    return [
        {
            id: 'pl-menu-profile-settings',
            title: t('common.settings'),
            icon: <SettingsIcon />,
            to: RoutePath.AccountSettingsProfile,
            base: RoutePath.AccountSettings,
        },
        {
            id: 'pl-menu-profile-help-center',
            title: t('Sidebar.helpCenter'),
            icon: <HelpCenterIcon />,
            external: true,
            href: ExternalRoutes.HelpCenter[i18n.language],
        },
        {
            id: 'pl-menu-profile-referral',
            title: t('Sidebar.referral'),
            icon: <ReferralIcon />,
            external: true,
            href: ExternalRoutes.ReferralProgram,
        },
    ];
};

export default useProfileMenuItems;
